module.exports = __webpack_public_path__ + "static/media/settings.a10b0d13.svg";